import { useEffect, useState, useMemo } from "react";
import React from 'react';
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { openPdfResponse } from "../../utils/openPdfInApp";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import {Row, Col, Button} from "reactstrap";
import {getWorkScheduleReport,getWorkScheduleReportCSV,getWorkScheduleReportPDF} from "../../services/ReportServices";
import {  DatePicker } from 'antd';
import { getUserAllowedPlants} from '../../services/PlantServices';
import moment  from 'moment';
import {displayErrorToast,displayError,parseBoolean,parseBooleanToString} from '../../helpers';
import ReportExportDropdown from '../../components/ReportExportDropdown';  

const {RangePicker} = DatePicker;

function WorkScheduleReportTable() 
{
    const InitialData = {
        records: []
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(false); 
    const [plants, setPlants] = React.useState([]);
    const [input, setInput] = useState({});

    // Initial state for from_date and to_date
    const initialFromDate = moment().startOf('month');
    const initialToDate =  moment();
    const [fromDate, setFromDate] = useState(initialFromDate);
    const [toDate, setToDate] = useState(initialToDate);
    const handleDateChange = (values) => {
        if ((values) && (values.length === 2)) {
        setFromDate(values[0]);
        setToDate(values[1]);
        }
    };

    React.useEffect(() => {
        //Load data for Plant dropdown
        getUserAllowedPlants(cookies)
        .then (
            plantList => {
                const plants = plantList.plant_list.filter(obj => obj.status).map(
                    plant => {
                        return { value: plant.id, label: plant.plant_alias }
                    }
                );
                setPlants(plants);
            }
        )
    }, []);

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        console.log(name+value+"name and value")
        setInput(values => ({...values, [name]: event.target.value}))
    }

    const columns = useMemo(
        () => [
            {
                fieldName: "schedule_date",
                headerName: 'Date'
            },
            {
                fieldName: 'plant_alias', 
                headerName: 'Plant Alias'
            },
            {
                fieldName:"customer_name",
                headerName:'Customer Name'
            },
            {
                fieldName: "project_name",
                headerName: 'Site/Project Name'
            },
            {
                fieldName: 'sales_order_no', 
                headerName: 'SO Number'
            },
            // {
            //     fieldName: 'site_address', 
            //     headerName: 'Location'
            // },
            {
                fieldName: 'grade', 
                headerName: 'Grade'
            },
            {
                fieldName: 'scheduled_qty', 
                headerName: 'Qty'
            },
            {
                fieldName: 'delivery_date', 
                headerName: 'Delivery Date'
            },
            {
                fieldName: 'delivery_time', 
                headerName: 'Delivery Time'
            },
            {
                fieldName: "delivery_mode",
                headerName: 'Service'
            },
            {
                fieldName: 'structure', 
                headerName: 'Structure'
            },
            {
                fieldName: "salesrep_name",
                headerName: 'Marketting'
            },
            {
                fieldName:"contact_mobile_no",
                headerName:'Mobile No'
            },
            {
                fieldName:"status",
                headerName:'Status'
            }
        ],
        [],);
   
    const handleCSVExport = (event) => {
    };

    
    const handlePDFExport = (event) => {
        console.log('PDF Export');
        exportAsPDF(
            'Work Schedule Report',
            columns
            .map(col=>({header: col.headerName, dataKey: col.fieldName })),
            data.records.map(wrkschedule_obj => ({
                schedule_date: wrkschedule_obj.schedule_date,
                    plant_alias: wrkschedule_obj.plant_alias,
                    project_name:wrkschedule_obj.project_name,
                    sales_order_no:  wrkschedule_obj.sales_order_no,
                    site_address:wrkschedule_obj.site_address,
                    grade:wrkschedule_obj.grade,
                    status : wrkschedule_obj.status,
                    scheduled_qty:wrkschedule_obj.scheduled_qty,
                    delivery_mode:wrkschedule_obj.delivery_mode,
                    structure:wrkschedule_obj.structure,
                    salesrep_name:wrkschedule_obj.salesrep_alias,
                    delivery_date:wrkschedule_obj.delivery_date,
                    contact_mobile_no:wrkschedule_obj.contact_mobile_no,
                    delivery_time: wrkschedule_obj.delivery_time
            })),
            'WorkScheduleReport.pdf'
        );
    };
    
    const constructFormData = () => {
        const EMPTY_STRING = '';
        return {
            plant_id:input.plant_id,
            from_date:fromDate.format('DD-MM-YYYY'),
            upto_date:toDate.format('DD-MM-YYYY')
          }
    }

    const handleDownloadCsv = () => {
        // console.log(JSON.stringify(constructFormData())+"submit")
        const inputs = constructFormData()
        if ((inputs.from_date) && (inputs.upto_date) && (inputs.plant_id))
        {
            getWorkScheduleReportCSV(cookies, constructFormData())
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'work_schedule_report.csv');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
            .catch((error) => {
                console.log(error.response.data);
                displayError(error.response.data);
            });
        }
        else 
        {
            Swal.fire("Plant,from_date,upto_date must not be empty.", "", "info");  
        }
    };

    
    const handleDownloadPdf = () => {
        console.log(JSON.stringify(constructFormData())+"handleDownloadPdf")
        const inputs = constructFormData()
        console.log(JSON.stringify(inputs)+"inputs handleDownloadPdf");
        if ((inputs.from_date) && (inputs.upto_date) && (inputs.plant_id))
            {
                getWorkScheduleReportPDF(cookies, constructFormData())
                .then(response => {
            openPdfResponse(response, {
                title: 'Work Schedule Report',
                downloadFileName: 'Work_schedule_report.pdf',
            });
            setIsLoading(false);
                })
        .catch(error => {
            console.error(error);
            displayError(error, 'Custom print/export failed');
            setIsLoading(false);
        });
            }
            else 
            {
                Swal.fire("Plant,from_date,upto_date must not be empty.", "", "info");  
            }
    };

    const handleGenerate = () => {
        console.log(JSON.stringify(constructFormData()) + "submit");
        const inputs = constructFormData();
        if ((inputs.from_date) && (inputs.upto_date) && (inputs.plant_id))
        {
            setIsLoading(true);
            getWorkScheduleReport(cookies, constructFormData())
            .then(response => {
                const tableData = response.work_schedule_report_list
                .map(wrkschedule_obj => ({
                    schedule_date: wrkschedule_obj.schedule_date,
                    plant_alias: wrkschedule_obj.plant_alias,
                    project_name:wrkschedule_obj.project_name,
                    sales_order_no:  wrkschedule_obj.sales_order_prefix + wrkschedule_obj.sales_order_no,
                    site_address:wrkschedule_obj.site_address_1 +", "+ wrkschedule_obj.site_address_2 +", "+ wrkschedule_obj.site_address_3,
                    grade:wrkschedule_obj.grade,
                    status : wrkschedule_obj.status,
                    scheduled_qty:wrkschedule_obj.scheduled_qty,
                    delivery_mode:wrkschedule_obj.delivery_mode,
                    structure:wrkschedule_obj.structure,
                    salesrep_name:wrkschedule_obj.salesrep_alias,
                    delivery_date:wrkschedule_obj.delivery_date,
                    delivery_time: wrkschedule_obj.delivery_time,
                    contact_mobile_no:wrkschedule_obj.contact_mobile_no,
                    customer_name:wrkschedule_obj.customer_name
                    }));
                setData({
                    records: tableData
                });
                setIsLoading(false);
            }).catch((error) => {
                console.log(error.response?.data);
                displayError(error.response?.data);
                setIsLoading(false);
            });
        }
        else
        {
            Swal.fire("Plant,From date,Upto date must not be empty.", "", "info");
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        handleGenerate();
    };

    return (
            <>
                <form className="form" onSubmit={handleSubmit}>
                    <div className="container"> 
                       <Row>
                            <Col xl={12} lg={12} md={12}>
                                <div className="report-legacy-filters form-row table-bordered  shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel ">
                                    <select className="browser-default custom-select col-sm-5"  onChange={handleChange} value={input.plant_id || ""} name ="plant_id" required id="myData">
                                        <option value="">Please Select Plant</option>
                                        {plants.map((item) => (
                                            <option key={item.value} value={item.value}>
                                                {item.label}</option>
                                        ))}
                                    </select>
                                    <br/><br/>

                                    <div className="report-legacy-filters-row">
                                    <RangePicker
                                        defaultValue={[initialFromDate, initialToDate]}
                                        format="DD-MM-YYYY"
                                        onChange={handleDateChange}
                                        style={{height:"40px",width:"270px"}}
                                    />

                                    <div className="report-legacy-filters-spacer" aria-hidden="true" />

                                    <div className="report-legacy-actions">
                                    <ReportExportDropdown
                                        onCSV={handleDownloadCsv}
                                        onPDF={handleDownloadPdf}
                                        disabled={isLoading}
                                    />
                                    <Button
                                        color="primary"
                                        className="list-page-toolbar-generate-btn"
                                        type="button"
                                        onClick={handleGenerate}
                                        disabled={isLoading}
                                    >
                                        Generate
                                    </Button>
                                    </div>
                                    </div>
                                </div>
                             </Col>
                        </Row> 
                    </div> 
                </form>
                <div className="container item-list-table-container">
                    <div className="table-responsive">
                        <ReactTableWrapper
                            title='Work Schedule Report'
                            columns={columns}
                            data={data.records}
                            onCSVExport={handleCSVExport}
                            onPDFExport={handlePDFExport}
                            isLoading={isLoading}
                            enableTableSearch={false}
                        />
                    </div>
                </div> 
            </>
);
}

export default WorkScheduleReportTable;